import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DataStudioParks, SelectedParksTurbines, TurbinePark } from 'app/shared/models/data-studio.model';

@Component({
  selector: 'app-data-assets',
  templateUrl: './data-assets.component.html',
  styleUrls: ['./data-assets.component.scss'],
  standalone: false
})
export class DataAssetsComponent implements OnChanges {
  constructor(private eRef: ElementRef) { }

  @Input() aggregationMethod?;
  @Input() park: DataStudioParks;
  @Input() disabled: boolean;
  @Output() selectedParksTurbines = new EventEmitter<SelectedParksTurbines>();
  @Output() removeParkList = new EventEmitter();

  public closedList = true;
  public allSelected = false;
  public text: string;
  public toggleClick: boolean;
  public turbines: TurbinePark[] = [];

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target) && !this.toggleClick) {
      this.closedList = true;
    }
    this.toggleClick = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.aggregationMethod) {
      if (changes.aggregationMethod.currentValue !== '') {
        this.allSelected = false;
        this.selectAllTurbines();
      }
    } else {
      if ((changes.park)) {
        if (changes.park.currentValue !== '') {
          this.allSelected = false;
          this.selectAllTurbines();
        }
      }
    }
  }

  public get selectedList() {
    const selectedTurbines = this.park.turbines
      .filter((turbine) => turbine.selected)
      .map((turbine) => turbine.code.replace('_', ' ').replace('_', ' '));
    return selectedTurbines.join(', ');
  }

  public get getSelected() {
    const selected = this.park.turbines
      ? this.park.turbines.filter((turbine) => turbine.selected)
      : [];
    return selected.length;
  }

  public toggleList() {
    this.toggleClick = true;
    this.closedList = !this.closedList;
  }

  public selectAllTurbines() {
    this.allSelected = !this.allSelected;
    if (this.park.turbines && this.park.turbines.length) {
      this.park.turbines.forEach((turbine) => {
        turbine.selected = this.allSelected;
        return turbine;
      });
    }
    this.turbines = this.allSelected ? this.park.turbines : [];

    this.selectedParksTurbines.emit({ parkCode: this.park.code, turbines: this.turbines });
  }

  public selectTurbine(event, turbine) {
    turbine.selected = event.checked;
    let turbinesSelected;
    this.park.turbines.forEach(item => {
      if (item === turbine) {
        turbinesSelected = item;
      }
    });
    if (event.checked) {
      this.turbines.push(turbinesSelected);
    } else {
      this.turbines = this.turbines.filter(turb => turb._id !== turbinesSelected._id);
    }
    this.allSelected = this.park.turbines.length === this.turbines.length ? true : false;
    this.selectedParksTurbines.emit({ parkCode: this.park.code, turbines: this.turbines });
  }

  public removeList() {
    this.removeParkList.emit({ parkName: this.park.name, turbines: this.turbines });
  }
}
